export function isDataValid(additionalInfo) {
    for (const key in additionalInfo) {
        if (isInvalid(key, additionalInfo[key])) return false;
    }
    return true;
}

export function validateField(field) {
    const error = isInvalid(field.name, field.value);
    return (error) ? failure(field, error) : success(field);
}

export function isInvalid(key, value) {
    switch (key) {
        case 'line_number':
            return (/^\d{0,4}$/.test(value)) ? null : 'Up to 4 digits allowed';
        case 'item_number':
        case 'agreement_code':
            return /^[\u00C0-\u00FF\w ]*$/.test(value) ? null : 'Alphanumeric characters only';
        case 'invoice_notes':
            return /^[\u00C0-\u00FF\w\n ]*$/.test(value) ? null : 'Alphanumeric characters only';
    }
    return false;
}

function success(field) {
    const input = field?.closest('nano-input, nano-select');
    if (input) input.showError('');
    return true;
}

function failure(field, message) {
    let input = field?.closest('nano-input, nano-select');
    if (input) input.showError(message);
    return false;
}
